"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
var React = require("react");
var sok_ui_1 = require("@caddigital/sok-ui");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var Icon_1 = require("components/Icon");
var Footer = function (props) { return (React.createElement(sok_ui_1.Footer, null,
    React.createElement(sok_ui_1.Button, { color: 'green', disabled: !props.isInputChanged || !props.isInputValid, iconRight: React.createElement(Icon_1.Icon, { className: 'fa-piggy-bank' }), text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/confirm'), onClick: function () {
            var folderUuid = props.selectedItems[0].uuid;
            var config = Number.isInteger(props.retentionTime) && props.retentionTimeUnits
                ? {
                    retentionTime: Number(props.retentionTime),
                    retentionTimeUnits: props.retentionTimeUnits
                }
                : null;
            props.setTTL(folderUuid, config);
            props.setRetentionTime(null);
            props.setRetentionTimeUnits();
        } }),
    React.createElement(sok_ui_1.Button, { color: 'dark-gray', iconRight: React.createElement(Icon_1.Icon, { className: 'fa-times-circle' }), text: (0, translation_1.getLocalization)('genericWarningConfirmationModal/cancel'), onClick: function () {
            props.setRetentionTime(null);
            props.setRetentionTimeUnits();
            props.closeDialog();
        } }))); };
exports.Footer = Footer;
